<template>
  <div>
    <b-modal id="modal-input" size="lg" centered title="Input Data Absensi Karyawan" header-bg-variant="primary" header-text-variant="light">
      <b-form>
        <b-form-group label="Karyawan" label-cols-md="3">
          <Multiselect
            v-model="data.dataKaryawan"
            :options="listKaryawan"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="-- Pilih Karyawan --"
            label="namaKaryawan"
            track-by="dataKaryawanId"
            @input="set_jadwal($event, data.tanggalAbsens)"
          ></Multiselect>
        </b-form-group>

        <b-form-group label="Tanggal" label-cols-md="3">
          <DatePicker v-model="data.tanggalAbsens" style="width: 100%" @change="set_jadwal(data.dataKaryawan, $event)"></DatePicker>
        </b-form-group>

        <b-form-group label="Status Absen" label-cols-md="3">
          <b-form-select v-model="data.statusIjin" :options="status"></b-form-select>
        </b-form-group>

        <!-- <b-form-group label="Tanggal Ijin" label-cols-md="3" v-if="data.statusIjin != 0">
          <date-picker
            v-model="data.tglIjin"
            style="width: 100%"
          ></date-picker>
        </b-form-group> -->

        <b-form-group label="Shift" label-cols-md="3" v-if="data.statusIjin == 0">
          <b-form-select disabled v-model="data.masterShiftId" :options="listShift" @change="setCabang($event)"></b-form-select>
        </b-form-group>

        <b-form-group v-if="data.statusIjin == 0" label="Masuk" label-cols-md="3">
          <b-form-timepicker v-model="data.masuk" locale="id"></b-form-timepicker>
        </b-form-group>

        <!-- <b-form-group
          v-if="data.statusIjin == 0"
          label="Jam Istirahat"
          label-cols-md="3"
        >
          <b-form-timepicker
            v-model="data.istirahat"
            locale="id"
            @input="itikiwir(data.break)"
          ></b-form-timepicker>
        </b-form-group>

        <b-form-group
          v-if="data.statusIjin == 0"
          label="Selesai Istirahat"
          label-cols-md="3"
        >
          <b-form-timepicker
            v-model="data.afterBreak"
            locale="id"
            @input="itikiwir(data.afterBreak)"
          ></b-form-timepicker>
        </b-form-group> -->

        <b-form-group v-if="data.statusIjin == 0" label="Pulang" label-cols-md="3">
          <b-form-timepicker v-model="data.keluar" locale="id"></b-form-timepicker>
        </b-form-group>

        <!-- <b-form-group
          v-if="data.statusIjin != 0 "
          label="Keterangan Ijin"
          label-cols-md="3"
        >
          <multiselect
            v-model="data.keteranganIjin"
            :options="listKeterangan"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="-- Pilih Keterangan --"
            label="namaIjin"
            track-by="id"
            @input="itikiwir(data.keteranganIjin)"
          ></multiselect>
        </b-form-group> -->
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input')"> Batal </b-button>
        <b-button variant="primary" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
export default {
  name: "modalInput",
  props: ["listShift", "listKaryawan"],
  data() {
    return {
      data: {
        dataKaryawan: "",
        dataKaryawanId: "",
        masuk: "",
        keluar: "",
        istirahat: "",
        afterBreak: "",
        statusIjin: "",
        tglIjin: "",
        keteranganIjin: "",
        tanggalAbsen: "",
        masterShiftId: null,
      },
      button: "Simpan",
      busy: false,
      // listKaryawan: [],
      shift: [],
      status: [
        { value: 0, text: "Berangkat" },
        { value: 1, text: "Cuti" },
        { value: 2, text: "Dinas" },
        { value: 3, text: "Cuti Hamil" },
        { value: 4, text: "Ijin" },
        { value: 5, text: "Sakit" },
        { value: 6, text: "Alpha" },
        { value: 7, text: "Ijin Keluarga Meninggal" },
        { value: 8, text: "Cuti Istri Melahirkan" },
        { value: 9, text: "Cuti Menikah" },
        // { value: 10, text: "Ijin Jatah Libur" },
      ],
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      dataKaryawanId: {
        required,
      },
      tanggalAbsens: {
        required,
      },
      masuk: {
        required: requiredIf(function () {
          return this.data.statusIjin == 0;
        }),
      },
      keluar: {
        required: requiredIf(function () {
          return this.data.statusIjin == 0;
        }),
      },
      statusIjin: {
        required,
      },
      keteranganIjin: {
        required: requiredIf(function () {
          return this.data.statusIjin == 1;
        }),
      },
    },
  },
  watch: {
    "data.statusIjin": function (val) {
      if (val != 0) {
        this.data.masuk = null;
        this.data.keluar = null;
      }
    },
  },
  mounted() {
    // this.getKaryawan();
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async set_jadwal(x, y) {
      let vm = this;
      let data = {};
      data.dataKaryawanId = x.dataKaryawanId;
      data.tanggalAbsen = vm.$moment(y).format("YYYY-MM-DD");
      if (x && y) {
        let sche = await vm.$axios.post("absensiKaryawanMobile/listJadwalShiftPerTanggalByDataKaryawanId", data);
        // console.log(sche.data.data);
        if (sche.data.data) {
          vm.data.masterShiftId = sche.data.data[0].masterShiftId;
          vm.data.masuk = sche.data.data[0].jamMasuk;
          vm.data.keluar = sche.data.data[0].jamKeluar;
        }
      }
    },
    // async getKaryawan() {
    //   let vm = this;
    //   let shift = await vm.$axios.get("masterShift/list");
    //   // console.log(shift.data.data,'shift');
    //   vm.shift = shift.data.data.map((item) => {
    //     return { value: item.id, text: item.kategoriShift };
    //   });
    // },
    setCabang(event) {
      let vm = this;
      vm.listShift.forEach((ele) => {
        if (ele.masterShiftId == event) {
          vm.data.cabangId = ele.cabangId;
        }
      });
    },
    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.data.dataKaryawanId = vm.data.dataKaryawan.dataKaryawanId;
      let tanggal = vm.$moment(vm.data.tanggalAbsens).format("YYYY-MM-DD");
      let jam = vm.$moment(vm.data.masuk, "HH:mm:ss").format("HH:mm");
      vm.data.tanggalAbsen = vm.$moment(tanggal + " " + jam, "YYYY-MM-DD HH:mm").add(7, "hours");
      vm.$axios
        .post("absensiKaryawanMobile/registerAbsensi", vm.data)
        .then((res) => {
          // console.log(res.data.message);
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL INPUT DATA ABSEN KARYAWAN",
              showing: true,
            });
            vm.$bvModal.hide("modal-input");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
            vm.$bvModal.hide("modal-input");
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
          // vm.$bvModal.hide("modal-input");
        });
    },
  },
};
</script>
